import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './faams_scholarship.css';
import logo from '../images/FAAMS__FAAMS_Goldlogo.png'
import axiosInstance from "../utils/axiosInstance";
import axios from 'axios';

function Faams_Scholarship({user, setUser}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const redirectURL = '/faams-scholarship'
    const toNewApplication = async() => {
        try {

            const response =
                await axiosInstance.get(`${API_URL}/faams-scholarship/generate`);
            const application_id = response.data.application_id
        
            navigate(`/faams-application/${application_id}/1`);
        } catch (err) {

            console.error(
                "Failed to generate application",
                err
            );

        }
    };
    const continueApplication = async() => {
        try {
            const response = await axiosInstance.get(`${API_URL}/faams-scholarship/continue-application`);
            const application_id = response.data.application_id
            if (application_id != "NOT_FOUND"){
                navigate(`/faams-application/${application_id}/1`)
            }
            else{
                alert("You have not started an application yet for your account, please select 'New Application'.")
            }
        } catch(err) {
            console.error(
                "Failed to fetch application",
                err
            );
        }
    };

    const token =
            localStorage.getItem('token');

    useEffect(() => {

    const fetchUser = async () => {

        if (!token) {
            navigate(`/login?redirectURL=${redirectURL}`);
            return;
        }

        try {

            const response =
                await axiosInstance.get(
                    `${API_URL}/me`
                );

            setUser(response.data);

        } catch (err) {

            console.error(
                "Failed to fetch user",
                err
            );

            navigate('/login');
        }
    };

    fetchUser();

}, [navigate, setUser, API_URL, token]);

    return (
        <div className='faams-scholarship-bg'>
            <div className="faams-content">
                <div className="faams-top-row">
                    <img src={logo} alt="faams-row-logo" />
                    <h1>FAAMS Scholarship</h1>
                </div>
                <h4>Eligibility</h4>
                <ol>
                    <li><p>Applicants must be an African American U.S. citizen or U.S. permanent resident at time of 
                    application.</p></li>
                    <li><p> Applicants must be current medical students or pre-medical students participating in the 
                    current medical school application cycle. All applicants awarded the scholarship must 
                    provide proof of medical school matriculation prior to fund disbursement. </p></li>
                </ol>
                <div className="new-app-button">
                    <button className="faams-scholarship-start-btn" onClick={toNewApplication}>New Application</button>
                </div>
                <div className="existing-app-button">
                    <button className="faams-scholarship-continue-btn" onClick={continueApplication}>Continue Application</button>
                </div>
                <div className='faams-page-bottom'>
                    <p>Please reach out to <strong>faamsinc@gmail.com</strong> with any questions.</p>
                </div>
            </div>
        </div>
    )
};

export default Faams_Scholarship;